import {IUser} from "../../store/user/types";
import {remergeAdminCondition, remergeSuperAdminCondition} from "../../firebase/conditions";
import {withAuthorization} from "../../firebase/withAuthorization";

const adminCondition = (authUser: IUser) => remergeAdminCondition(authUser)
const superAdminCondition = (authUser: IUser) => remergeSuperAdminCondition(authUser)
export const AdminZone = withAuthorization(adminCondition)("span")
export const SuperAdminZone = withAuthorization(superAdminCondition)("span")
